import React, { useState, useRef, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Navbar from '../../../../components/Navbar';
import SideBar from '../../../../components/SideBar';
import HrDropdown from './component/hrdropdown';
import ReactDatePicker from 'react-datepicker';
import JobDescription from './component/job-description-dropdown';
import CommanDropdown from '../../../../components/dropdown';
import EmpoymentDetails from './component/employment-details';
import AcademicDetails from './component/academic-details';
import AmendmentLogs from './component/amenment-logs';
import { API_URL } from '../../../../constants';
import moment from 'moment';
import { FileUploader } from './component/FileUploader';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import CustomDatePicker from '../../../../components/Custom-Datepicker';
import { FaSpinner } from 'react-icons/fa';
import validate from './component/validate';
const AddCandidate = () => {
    const [pageLoading, setPageLoading] = useState(true);
    const [submitted, setSubmit] = useState(false);
    let [errors, setErrors] = useState({});
    /* Initial Form Data*/
    const initialFormData = {
        job_title: '',
        applied_date: '',
        hr: '',
        first_name: '',
        last_name: '',
        gender: '',
        email_id: '',
        dob: "",
        mobile_no: '',
        mobile_no_2: '',
        company_name: '',
        relevant_exp_in_years: '',
        ctc: '',
        referral_type: '',
        position: '',
        reason_for_change: '',
        ectc: '',
        note: '',
        experience_in_years: '',
        notice_period: '',
        location: '',
        employment_summary: [],
        academic_details: [],
        resume: '',
    };
    /* Initial State To set form Data*/
    const ref = useRef();
    const [formData, setFormData] = useState(initialFormData);
    const [selectedJobTitle, setSelectedJobTitle] = useState({});
    const [jobtitleOption, setJobTitleOption] = useState([]);
    const [hrOptions, setHrOptions] = useState([]);
    const { id } = useParams()
    useEffect(() => {
        fetchCandidateDetails(id);
    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleDateChange = (date, name) => {
        setFormData(prevState => ({
            ...prevState,
            [name]: moment(date).format('DD-MM-YYYY')
        }));
    }
    const onEmploymentDataChange = (data) => {
        formData.employment_summary = data;
    }
    const onAcademicDataChange = (data) => {
        formData.academic_details = data;
    }
    /*File uploaded Component*/
    const [fileName, setFileName] = useState("");
    const handleFile = async (file) => {
        setFileName(file.name);
        setFormData(prevState => ({
            ...prevState,
        }));

        const url = 'http://localhost:8000/api/resume-upload';
        const formFilePost = new FormData();
        formFilePost.append('resume', file);
        formFilePost.append('fileName', file.name);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        let response = await axios.post(url, formFilePost, config);
        setFormData(prevState => ({
            ...prevState,
            resume: response.data.file_name
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let mandatory_field = ['first_name', 'last_name', 'gender', 'email_id', 'DateOfBirth', 'mobile_no', 'referral_type', 'job_title', 'applied_date', 'hr'];

        let isFormInvalid = false;
        for (let field of mandatory_field) {
            let error =  validate([field], formData[field], formData);
            if (error.status == true) {
                isFormInvalid = true;
            }
            setErrors(errors => ({
                ...errors, [field]: error
            }));

        }
        if (!isFormInvalid) {
            setSubmit(true);
            const url = API_URL + 'candidateprocess';
            let updatedFormData = formData;
            updatedFormData.ID = id;
            updatedFormData.hr = updatedFormData.hr?.value;
            updatedFormData.job_title = updatedFormData.job_title?.value;
            setFormData(updatedFormData);
            let dataToSend = updatedFormData;
            const config = {
                headers: {
                    'content-type': 'application/json',
                },
            };
            try {
                let response = await axios.post(url, dataToSend, config);
                if (response.data.status === 'success') {
                    toast.success(response.data.message);
                    setSubmit(false);
                    setTimeout(() => {
                        window.location.href = '/candidate-in-process'
                    }, 5000)
                } else {
                    setSubmit(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmit(false);
                    toast.error('Something went wrong.');
            }
        }
    }
    const fetchCandidateDetails = async (id) => {
        const url = API_URL + 'newapplication/' + id;
        let response = await axios.get(url);
        const response2 = await axios.get(`http://localhost:8000/api/fetch-job-titles`);
   
        const jobtitleOption = response2.data.map(option => ({
            value: option.value,
            label: option.text
        }));
        let candidateDetails = response.data;
        let selectedJobTitle = jobtitleOption.find(o => o.value == candidateDetails.JobDescriptionID);
        setJobTitleOption(jobtitleOption);

        const response3 = await axios.get(`http://localhost:8000/api/fetch-hr`);
        const hrOptions = response3.data.Hr.map(option => ({
            value: option.value,
            label: option.text
        }));
        setHrOptions(hrOptions);
        let selectedHr = hrOptions.find(o => o.value == candidateDetails?.RecruiterID);


        let fetchCandidateDetails = {
            job_title: selectedJobTitle,
            applied_date: moment(candidateDetails?.AppliedDate).format('DD-MM-YYYY'),
            hr: selectedHr,
            first_name: candidateDetails?.FirstName,
            last_name: candidateDetails?.LastName,
            gender: candidateDetails?.Gender_020,
            email_id: candidateDetails?.EmailID,
            dob: moment(candidateDetails?.DateOfBirth).format('DD-MM-YYYY'),
            mobile_no: candidateDetails?.MobileNo,
            mobile_no_2: '',
            company_name: candidateDetails?.CurrentCompanyName,
            relevant_exp_in_years: candidateDetails?.CurrentRelevantExperienceInYears,
            ctc: Number(candidateDetails?.CurrentCTC).toFixed(2),
            referral_type: candidateDetails?.CandidateReferralType_174,
            position: candidateDetails?.CurrentPosition,
            reason_for_change: candidateDetails?.ReasonForChange,
            ectc: Number(candidateDetails?.ExpectedCTC).toFixed(2),
            experience_in_years: candidateDetails?.CurrentExperienceInYears,
            notice_period: candidateDetails?.NoticePeriod,
            location: candidateDetails?.CurrentLocation,
            resume: candidateDetails?.ResumePath,
        }
        setFormData(fetchCandidateDetails);

        setPageLoading(false);

    }
    const handleDropdownChange = (e, name) => {
        const { value } = typeof e?.target == 'undefined' ? e : e?.target;
        setFormData({
            ...formData,
            [name]: typeof e?.target == 'undefined' ? e : value
        });

    };
    if (pageLoading) {
        return (
            <>
                <p class="position-absolute top-50 start-50 translate-middle text-center"><FaSpinner class="spinner" /></p>
            </>
        );
    } else {
        return (

            <div>
                <div className="Nav" >
                    <Navbar />
                </div>
                <div className="nest-page">
                    <SideBar />
                    <div className='Container' id='form-input-section'>
                        <div className='mx-3'>
                            <h3 className="heading skill-heading">
                                <i className="fa fa-user"></i>Candidate Details
                            </h3>
                        </div>
                        <form id='formOne' className='rounded bg-white'>
                            <div className="container">
                                <div className="row">
                                    <div className='col-sm-12'>
                                        <div className="card">
                                            <div className='card-header'>
                                                <h5>Job Details</h5>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-sm-3'>
                                                        <Form.Group className="col-form-label">
                                                            <Form.Label>Job Title <span className='required'>*</span></Form.Label>
                                                            <Select options={jobtitleOption} onChange={(selected) => { handleDropdownChange(selected, 'job_title') }}
                                                                selected={selectedJobTitle}
                                                                value={formData.job_title} name="job_title" />
                                                            <span class='error'>{errors?.job_title?.message}</span>
                                                        </Form.Group>
                                                    </div>
                                                    <div className='col-sm-3'>
                                                        <div className='col-form-label'>
                                                            <label className='form-label'>Applied Date<span className='required'>*</span></label>
                                                            <ReactDatePicker minDate={new Date()} changeYear
                                                                changeMonth showPopperArrow showIcon icon="fa fa-calendar" className="form-control" placeholderText='Applied Date' format="d-MM-YYYY" name='applied_date' id='applied_date' value={formData.applied_date} onChange={(date) => { handleDateChange(date, 'applied_date') }} />
                                                            <span class='error'>{errors?.applied_date?.message}</span>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-3'>
                                                        <Form.Group className="col-form-label">
                                                            <Form.Label>HR Name <span className='required'>*</span></Form.Label>
                                                            <Select onChange={(selected) => { handleDropdownChange(selected, 'hr') }} value={formData.hr} name="hr" options={hrOptions} />
                                                            <span class='error'>{errors?.hr?.message}</span>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 mt-2'>
                                        <div className="card">
                                            <div className='card-header'>
                                                <h5>Personal Details</h5>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>First Name<span className='required'>*</span></label>
                                                        <input type='text' className='form-control' name="first_name" placeholder='First Name' value={formData.first_name} onChange={handleChange} />
                                                        <span class='error'>{errors?.first_name?.message}</span>
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Last Name<span className='required'>*</span></label>
                                                        <input type='text' className='form-control' name="last_name" placeholder='Last Name' value={formData.last_name} onChange={handleChange} />
                                                        <span class='error'>{errors?.last_name?.message}</span>
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Gender<span className='required'>*</span></label>
                                                        <CommanDropdown name='gender' url={API_URL + 'fetch-gender'} value={formData.gender} handleChange={handleChange} />
                                                        <span class='error'>{errors?.gender?.message}</span>
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Email ID<span className='required'>*</span></label>
                                                        <input type='text' className='form-control' name="email_id" placeholder='Email' value={formData.email_id} onChange={handleChange} />
                                                        <span class='error'>{errors?.email_id?.message}</span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>DOB<span className='required'>*</span></label>

                                                        <CustomDatePicker handleChange={handleChange} value={formData.dob} name='dob' id='DateOfBirth' placeholderText="Date Of Birth" maxDate={new Date()}></CustomDatePicker>
                                                        <span class='error'>{errors?.dob?.message}</span>
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Mobile No.<span className='required'>*</span></label>
                                                        <input type='text' className='form-control' name="mobile_no" placeholder='Mobile No' value={formData.mobile_no} onChange={handleChange} />
                                                        <span class='error'>{errors?.mobile_no?.message}</span>
                                                    </div>

                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Mobile No.2</label>
                                                        <input type='text' className='form-control' name="mobile_no_2" placeholder='Alternate Mobile No' value={formData.mobile_no_2} onChange={handleChange} />

                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-sm-12 mt-2'>
                                        <div className="card">
                                            <div className='card-header'>
                                                <h5>Company Details</h5>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Company Name</label>
                                                        <input type='text' className='form-control' name="company_name" placeholder='Company Name' value={formData.company_name} onChange={handleChange} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Rel.Exp. In Years</label>
                                                        <input type='text' className='form-control' name="relevant_exp_in_years" placeholder='Experience' value={formData.relevant_exp_in_years} onChange={handleChange} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>CTC (in Rupees)</label>
                                                        <input type='text' className='form-control' name="ctc" placeholder='CTC' value={formData.ctc} onChange={handleChange} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Source<span className='required'>*</span></label>
                                                        <CommanDropdown name="referral_type" url={API_URL + 'fetch-referral-type'} value={formData.referral_type} handleChange={handleChange} placeholder='Souce' />
                                                        <span class='error'>{errors?.referral_type?.message}</span>

                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Position</label>
                                                        <input type='text' className='form-control' name="position" placeholder='Position' onChange={handleChange} value={formData.position} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Reason For Change</label>
                                                        <textarea className='form-control' name="reason_for_change" placeholder='Reason For Change' onChange={handleChange} value={formData.reason_for_change}>{formData.reason_for_change}</textarea>
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Expected CTC (in Rupees)</label>
                                                        <input type='text' className='form-control' name="ectc" placeholder='ECTC' value={formData.ectc} onChange={handleChange} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Notes</label>
                                                        <input type='text' className='form-control' name="note" placeholder='Note' value={formData.note} onChange={handleChange} />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Exp. In Years</label>
                                                        <input type='text' className='form-control' name="experience_in_years" placeholder='Experience In Year' value={formData.experience_in_years} onChange={handleChange} />
                                                    </div>

                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Notice Period</label>
                                                        <input type="text" className='form-control' name="notice_period" placeholder='Notice Period' value={formData.notice_period} onChange={handleChange} />
                                                    </div>
                                                    <div className='col-sm-3 form-group'>
                                                        <label className='form-label'>Location</label>
                                                        <input type='text' className='form-control' name="location" placeholder='Location' value={formData.location} onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-sm-12 mt-2'>
                                        <div className='card'>
                                            <div className='card-header'>
                                                <h5>Employment Summary</h5>
                                            </div>
                                            <div className='card-body'>
                                                <EmpoymentDetails onEmploymentDataChange={onEmploymentDataChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 mt-2'>
                                        <div className='card'>
                                            <div className='card-header'>
                                                <h5>Academic Details</h5>
                                            </div>
                                            <div className='card-body'>
                                                <AcademicDetails onAcademicDataChange={onAcademicDataChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 mt-2'>
                                        <div className='card'>
                                            <div className='card-header'>
                                                <h5>Amendment Log</h5>
                                            </div>
                                            <div className='card-body'>
                                                <AmendmentLogs />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-4 mt-2'>
                                        <FileUploader handleFile={handleFile} />
                                        {fileName ? <p>Resume: {fileName}</p> : null}
                                        {formData.resume && !fileName ? <p>Resume: <a href={'http://localhost:8000/storage/uploads/resume/'+formData.resume} target='_blank'>{formData.resume}</a></p> : null}

                                    </div>

                                    <div className='col-sm-8  mt-2'>

                                        <div className='d-flex justify-content-end'>
                                            <div className='d-flex'>
                                                <div>
                                                    <button type="reset" className='btn btn-info me-2 pull-right'>Reset</button>
                                                </div>
                                                <div>
                                                    <button disabled={submitted ? true : false} onClick={handleSubmit} type="" className="btn btn-info">{submitted ? <FaSpinner class="sm-spinner" /> : 'Submit'}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddCandidate;